import React, { useRef } from "react";
import { useState } from "react";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import "../Dashboard/Dashboard.css";
import Select from "react-select";
import { MdContentCopy } from "react-icons/md";
import { TiEyeOutline } from "react-icons/ti";
import { MdOutlinePersonAddAlt1 } from "react-icons/md";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useSelector } from "react-redux/es/exports";
import Pagination from "../../utils/Pagination";
import axiosinstances from "../../Helper/useAxios";
import { v4 as uuid4 } from "uuid";
import {
  copyTextToClipboard,
  darkenColor,
  isSuperAdmin,
  isUserAdmin,
  nopagepermission,
  primaryColor,
  requestLoading,
  stylesofStype,
} from "../../utils/comman/Common";
import {
  searchbyOptionsForTicket,
  createdOnDate,
  TICKETID,
} from "../../utils/Constant";

import { useNavigate } from "react-router-dom";
import UpdatTicket from "../Model/UpdateToken";
import UILoader from "../../utils/comman/loader";

const TicketList = () => {
  const roles = useSelector((state) => state.authReducer?.auth?.roles);
  // const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const accessPath = process.env.REACT_APP_accessPath;
  const profileInfo = useSelector(
    (state) => state.getprofilereducer?.getprofile
  );
  const sessionId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.sessionId
  );
  const reqId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.requestId
  );
  const dropdownAlignClass = useSelector(
    (state) => state.copyDetailsReducer?.copyMerchantDetails
  );
  //console.log("sessionId", sessionId, reqId);
  const e = JSON.parse(sessionStorage.getItem("token"));

  const [axiosInstance] = axiosinstances();
  const selectedId = useSelector((state) => state.selectedRetailerReducer.id);
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [isExportable, setIsExportable] = useState(false);
  const [finalSelectedStatus, setFinalSelectedStatus] = useState();
  const [search, setsearch] = useState("");
  const [searchTyping, setSearchTyping] = useState(false);
  const [formDate, setFormDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [attachmentId, setattachmentId] = useState(null);

  const [show, setShow] = useState(false);
  //statusDate
  const today = new Date().toLocaleDateString("en-CA");
  //const [statusDate, setStatusDate] = useState(today);
  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 1,
    postsPerPage: 20,
    totalPost: 0,
    totalPages: 0,
  });
  const [searched, setSearched] = useState({
    name: "",
    typing: false,
    typingTimeout: 0,
  });

  const [table, settable] = useState([]);
  const [backupTableData, setBackupTableData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [searchedBy, setSearchedBy] = useState();
  const [searchedByItem, setSearchedByItem] = useState(
    searchbyOptionsForTicket
  );
  const [searchedByItemShow, setSearchedByItemShow] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const toggleDropdown = (e) => {
    console.log("Filter toggle clicked");
    e.stopPropagation();
    setIsDropdownOpen((prevState) => !prevState);
  };
  const mid = JSON.parse(sessionStorage.getItem("mid"));
  const finalStatus = selectedStatus.map((item) => item.value);

  const [transactionStatuswithAmount, setTransactionStatuswithAmount] =
    useState([
      {
        id: "SUCCESS",
        count: 0,
        total: 0,
      },
      {
        id: "PENDING",
        count: 0,
        total: 0,
      },
      {
        id: "FAILED",
        count: 0,
        total: 0,
      },
    ]);
  const [ticketRequest, setticketRequest] = useState({
    txnDetails: "",
    status: "",
    createdBy: profileInfo?.id,
    description: "",
    userUtr: "",
    userTxnDate: "",
    comments: "",
    attachmentId: "",
  });
  // console.log("ticketRequest", ticketRequest);
  const fromatedFromDate = formDate !== "" ? `${formDate}T00:00:00` : "";
  const formatedToDate = toDate !== "" ? `${toDate}T23:59:59` : null;
  var request = {
    mid: mid,
    resolved: [true, false],
    fromDate: fromatedFromDate,
    toDate: formatedToDate,
    user: null,
    merchant: false,
    fromDate: null,
    toDate: null,
    statuses: finalStatus,
    pageNum: paginationDetails.currentPage - 1,
    perPage: paginationDetails.postsPerPage,
  };
  const txnFromDateHandler = (e) => {
    setFormDate(e.target.value);
  };
  const txnToDateHandler = (e) => {
    setToDate(e.target.value);
  };
  const getUniqId = () => {
    const uuid = uuid4();
    const uuidWithoutDashes = uuid.replace(/-/g, "").toUpperCase();
    return uuidWithoutDashes;
  };
  console.log("paginationDetails", paginationDetails);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    setSearchedByItemShow(true);
    setSearchedBy();
  }, [search]);

  useEffect(() => {
    if (Array.isArray(selectedStatus) && selectedStatus.length > 0) {
      const values = selectedStatus.map((val) => val.value);
      setFinalSelectedStatus(values);
    } else if (Array.isArray(selectedStatus) && selectedStatus.length === 0) {
      setFinalSelectedStatus([]);
    }
  }, [selectedStatus]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    // const res = await uploadFile(file);
  };

  const searchdata = (event) => {
    if (searched.typingTimeout) {
      clearTimeout(searched.typingTimeout);
    }
    if (!searched.typing) {
      // setRetailerList([])
    }

    if (event.target.value !== "") {
      const trimSearch = event.target.value;
      setSearched({
        name: trimSearch,
        typing: true,
        typingTimeout: setTimeout(function () {
          // sendToParent(searched.name);
          if (event.target.value) {
            setSearchTyping(true);
            setsearch(trimSearch);
          } else {
          }
        }, 500),
      });
    } else {
      setsearch(event.target.value);
      setSearched({
        typing: false,
      });
    }
  };

  useEffect(() => {
    let url = "";

    if (isSuperAdmin(id)) {
      url = `/api/v1/finxpay/complaint/list?pageNo=${paginationDetails?.currentPage}&pageSize=${paginationDetails?.postsPerPage}`;
      if (formDate !== "" && toDate !== "") {
        url = url + `&fromDate=${formDate}&toDate=${toDate}`;
      }
    } else if (isUserAdmin(id)) {
      url = `/api/v1/finxpay/complaint/list?pageNo=${paginationDetails?.currentPage}&pageSize=${paginationDetails?.postsPerPage}&createdBy=${id}`;
      if (formDate !== "" && toDate !== "") {
        url = url + `&fromDate=${formDate}&toDate=${toDate}`;
      }
    }

    if (url) {
      callApis(url);
    }
  }, [id]); // ✅ Added dependencies

  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": id,
    "access-path": accessPath,
  };
  async function callApis(url) {
    await fetchpagedata(url);
  }

  const fetchpagedata = async (url) => {
    setDataLoading(true);
    try {
      const res = await axiosInstance.get(url, { headers });

      if (res.status === 200 && res?.data?.success) {
        settable(res.data.complaintList);

        setDataLoading(false);
        setIsDataLoaded(true);
        setPaginationDetails((prev) => {
          return {
            ...prev,
            totalPost: res.data?.totalNoOfElements,
            totalPages: res.data?.totalPages,
            currentPage: res.data?.activePage,
          };
        });
      } else {
        toast.error(res?.data?.msg);
        throw new Error(res?.data?.msg);
      }
    } catch (error) {
      setDataLoading(false);
      setIsDataLoaded(false);
      console.error("Error", error);

      toast.error(error?.msg);
      return false;
    }
  };

  const fetchSingleTicket = async (url) => {
    setDataLoading(true);
    try {
      const res = await axiosInstance.get(url, { headers });

      if (res.status === 200 && res?.data?.success) {
        const data = [res.data?.ticket] || [];
        settable(data);

        setDataLoading(false);
        setIsDataLoaded(true);
        setPaginationDetails((prev) => {
          return {
            ...prev,
            totalPost: 1,
            totalPages: 20,
            currentPage: 1,
          };
        });
      } else {
        const data = [];
        settable(data);

        setDataLoading(false);
        setIsDataLoaded(true);
        setPaginationDetails((prev) => {
          return {
            ...prev,
            totalPost: 1,
            totalPages: 20,
            currentPage: 1,
          };
        });
        toast.error(res?.data?.msg);
        // throw new Error(res?.data?.message);
      }
    } catch (error) {
      setDataLoading(false);
      setIsDataLoaded(false);
      console.error("Error", error);

      toast.error(error?.message);
      return false;
    }
  };

  useEffect(() => {
    if (search.length > 2) {
      if (searchedBy == TICKETID) {
        const url = `api/v1/finxpay/complaint/getComplaint/${search}`;

        fetchSingleTicket(url);
      }
    }
  }, [searchedBy]);

  const getCurrentDateTime = () => {
    const currentDate = new Date();
    const formattedDate = currentDate
      .toISOString()
      .slice(0, 10)
      .replace(/-/g, "");
    const formattedTime = currentDate
      .toTimeString()
      .slice(0, 8)
      .replace(/:/g, "");
    return `${formattedDate}_${formattedTime}`;
  };

  // const convertToXLSX = (data, fileName) => {
  //   // Define the headers you want to keep
  //   const selectedHeaders = [
  //     "ticketId",
  //     "createdBy",
  //     "createdOn",
  //     "service",
  //     "operator",
  //     "description",
  //     "currentStatus",
  //     "txnId",
  //     "lastAssignedTo",
  //     "commentList",
  //   ];

  //   // Map data to include only selected headers
  //   const filteredData = data.map((item) => {
  //     let newItem = {};
  //     selectedHeaders.forEach((key) => {
  //       newItem[key] = item[key] || "";
  //     });
  //     return newItem;
  //   });

  //   // Convert to Excel format
  //   const worksheet = XLSX.utils.json_to_sheet(filteredData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  //   // Generate and download the file
  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });
  //   const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  //   saveAs(blob, `${fileName}.xlsx`);
  // };
  const convertToXLSX = (data, fileName) => {
    // Define the headers you want to keep
    const selectedHeaders = [
      "ticketId",
      "createdBy",
      "createdOn",
      "service",
      "operator",
      "description",
      "currentStatus",
      "txnId",
      "lastAssignedTo",
      "commentList",
    ];

    // Map data to include only selected headers
    const filteredData = data.map((item) => {
      let newItem = {};

      selectedHeaders.forEach((key) => {
        if (key === "commentList" && Array.isArray(item[key])) {
          // Extract only comment values and join them with commas
          newItem[key] = item[key].map((c) => c.comment).join(", ");
        } else {
          newItem[key] = item[key] || "";
        }
      });

      return newItem;
    });

    // Convert to Excel format
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate and download the file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  };

  const onExportData = async () => {
    if (formDate == "" || toDate == "") {
      toast.error("Please select from date and to date");
      return;
    }

    let url = "";

    if (isSuperAdmin(id)) {
      url = `/api/v1/finxpay/complaint/list?pageNo=${1}&pageSize=${
        paginationDetails?.postsPerPage
      }&fromDate=${formDate}&toDate=${toDate}`;
    } else {
      url = `/api/v1/finxpay/complaint/list?pageNo=${1}&pageSize=${
        paginationDetails?.postsPerPage
      }&createdBy=${id}&fromDate=${formDate}&toDate=${toDate}`;
    }

    const getTotalElement = async (url) => {
      setDataLoading(true);
      try {
        const res = await axiosInstance.get(url, { headers });

        if (res.status === 200 && res?.data?.success) {
          const totalElements = res.data?.totalNoOfElements;
          if (totalElements > 0) {
            let url = "";

            if (isSuperAdmin(id)) {
              url = `/api/v1/finxpay/complaint/list?pageNo=${1}&pageSize=${totalElements}&fromDate=${formDate}&toDate=${toDate}`;
            } else {
              url = `/api/v1/finxpay/complaint/list?pageNo=${1}&pageSize=${totalElements}&createdBy=${id}&fromDate=${formDate}&toDate=${toDate}`;
            }
            await fetchpagedata(url);
          } else {
            toast.error("No data found");
          }
        } else {
          toast.error(res?.data?.msg);
          throw new Error(res?.data?.msg);
        }
      } catch (error) {
        setDataLoading(false);
        setIsDataLoaded(false);
        console.error("Error", error);

        toast.error("Something went wrong");
        return false;
      }
    };

    const fetchpagedata = async (url) => {
      setDataLoading(true);
      try {
        const res = await axiosInstance.get(url, { headers });

        if (res.status === 200 && res?.data?.success) {
          setDataLoading(false);
          setIsDataLoaded(false);
          const fileName = `${getUniqId()}_${getCurrentDateTime()}`;
          convertToXLSX(res?.data.complaintList, fileName);
        } else {
          toast.error(res?.data?.msg);
          throw new Error(res?.data?.msg);
        }
      } catch (error) {
        setDataLoading(false);
        setIsDataLoaded(false);
        console.error("Error", error);

        toast.error("Something went wrong");
        return false;
      }
    };

    if (url && request) {
      const fileExport = await getTotalElement(url);
    }
  };

  //applyStatus
  const applyStatus = async (e) => {
    e.preventDefault();
    if (formDate == "" || toDate == "") {
      toast.error("Please select from date and to date");
      return;
    }

    let url = "";

    if (isSuperAdmin(id)) {
      url = `/api/v1/finxpay/complaint/list?pageNo=${1}&pageSize=${
        paginationDetails?.postsPerPage
      }`;
      if (formDate !== "" && toDate !== "") {
        url = url + `&fromDate=${formDate}&toDate=${toDate}`;
      }
    } else {
      url = `/api/v1/finxpay/complaint/list?pageNo=${1}&pageSize=${
        paginationDetails?.postsPerPage
      }&createdBy=${id}`;
      if (formDate !== "" && toDate !== "") {
        url = url + `&fromDate=${formDate}&toDate=${toDate}`;
      }
    }

    if (url) {
      callApis(url);
    }
  };
  const ticketChangeHandle = (e) => {
    const { name, value } = e.target;

    if (name == "userUtr") {
      const sanitizedValue = value.replace(/\D/g, "").substring(0, 12);
      setticketRequest({
        ...ticketRequest,
        userUtr: sanitizedValue,
      });
      return;
    }

    if (name !== "userUtr") {
      setticketRequest((pre) => ({ ...pre, [name]: value }));
    }
  };

  const resetApply = () => {
    setFinalSelectedStatus([]);
    setSelectedStatus([]);
    setIsExportable(false);
    setIsDropdownOpen(false);
    setFormDate("");
    setToDate("");
    request["statuses"] = [];
    request["fromDate"] = null;
    request["toDate"] = null;
    // if (url && request) {
    //   callApis(url, request);
    // }
  };

  //editPlans
  const clearSearchData = () => {
    setsearch("");
    setSearchedBy();
    setSearched({ name: "", typing: false, typingTimeout: 0 });
    resetApply();
    setDataLoading(false);
    setIsDataLoaded(true);
    let url = "";

    if (isSuperAdmin(id)) {
      url = `/api/v1/finxpay/complaint/list?pageNo=${paginationDetails?.currentPage}&pageSize=${paginationDetails?.postsPerPage}`;
      // if (formDate !== "" && toDate !== "") {
      //   url = url + `&fromDate=${formDate}&toDate=${toDate}`;
      // }
    } else {
      url = `/api/v1/finxpay/complaint/list?pageNo=${paginationDetails?.currentPage}&pageSize=${paginationDetails?.postsPerPage}&createdBy=${id}`;
      // if (formDate !== "" && toDate !== null) {
      //   url = url + `&fromDate=${formDate}&toDate=${toDate}`;
      // }
    }

    if (url) {
      callApis(url);
    }
  };

  //editPlans
  const clearFilterhData = () => {
    setsearch("");
    setSearchedBy();
    setSearched({ name: "", typing: false, typingTimeout: 0 });
    resetApply();
    setDataLoading(false);
    setIsDataLoaded(true);
    setFormDate("");
    setToDate("");
    let url = "";

    if (isSuperAdmin(id)) {
      url = `/api/v1/finxpay/complaint/list?pageNo=${1}&pageSize=${
        paginationDetails?.postsPerPage
      }`;
    } else {
      url = `/api/v1/finxpay/complaint/list?pageNo=${1}&pageSize=${
        paginationDetails?.postsPerPage
      }&createdBy=${id}`;
    }

    if (url) {
      callApis(url);
    }
  };

  // const percentage = 66;
  // console.log("transactionStatuswithAmount", transactionStatuswithAmount);
  const initialValue = 0;
  const sumOfallSatus = transactionStatuswithAmount.reduce(
    (accumulator, currentValue) => accumulator + (currentValue?.count || 0),
    initialValue
  );
  const openDetailsPage = (data) => {
    navigate("/ticket-details", { state: { data: data, headers: headers } });
  };

  const bgColor = search.length > 3 ? "#FEC7B4" : "#848587";

  const paginate = (pageNumber) => {
    // console.log("pageNumber", pageNumber);
    let url = "";

    if (isSuperAdmin(id)) {
      url = `/api/v1/finxpay/complaint/list?pageNo=${pageNumber}&pageSize=${paginationDetails?.postsPerPage}`;
      if (formDate !== "" && toDate !== "") {
        url = url + `&fromDate=${formDate}&toDate=${toDate}`;
      }
    } else {
      url = `/api/v1/finxpay/complaint/list?pageNo=${pageNumber}&pageSize=${paginationDetails?.postsPerPage}&createdBy=${id}`;
      if (formDate !== "" && toDate !== "") {
        url = url + `&fromDate=${formDate}&toDate=${toDate}`;
      }
    }
    if (url) {
      callApis(url);
    }
  };
  // setPaginationDetails((pre) => ({ ...pre, currentPage: pageNumber }));
  return (
    <React.Fragment>
      {loading ? (
        requestLoading()
      ) : (
        <>
          <div className="mid">
            <div className="container-fluid">
              <div className="maincard">
                <div className="tab-content" id="mobiletab">
                  <div
                    className="tab-pane fade show active"
                    id="nav-mobi"
                    role="tabpanel"
                    aria-labelledby="mobile-tab"
                  >
                    <div style={{ marginTop: "0px" }} className="head">
                      <h3
                        style={{ marginTop: "3px" }}
                        className="hide-on-mobile"
                      >
                        Ticket List
                      </h3>
                      <div className="search-filter-mobile-view">
                        {/* <div
                          // id='upper_margin_at_txn_history'
                          className="dropdown fltr"
                        >
                          <button
                            type="button"
                            title="filter"
                            className="filter dropdown-toggle"
                            id="fillist"
                            data-bs-boundary="viewport"
                            onClick={toggleDropdown}
                            aria-expanded={isDropdownOpen}
                          >
                            Filter
                          </button>
                          <div
                            className={`dropdown-menu ${dropdownAlignClass} ${
                              isDropdownOpen ? "show" : ""
                            }`}
                            id="filterbox"
                            aria-labelledby="fillist"
                          >
                            <form onSubmit={applyStatus}>
                              <div className="col-12 col-md-12 mb-2 border-bottom ">
                                <div className="form-floating">
                                  <div className="formselect mb-2">
                                    <label>Selected Status</label>
                                    <Select
                                      className="basic-multi-select"
                                      styles={stylesofStype}
                                      closeMenuOnSelect={false}
                                      components={{
                                        IndicatorsContainer: () => null,
                                        IndicatorSeparator: () => null,
                                      }}
                                      isMulti
                                      options={TicketStatusoptions}
                                      onChange={changeHandler}
                                      value={selectedStatus}
                                      placeholder=" select multiple option"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="filters">
                                <label for="select-state">From Date:</label>
                                <input
                                  type="date"
                                  onChange={fromDateHandler}
                                  value={formDate}
                                />
                              </div>

                              <div className="filters">
                                <label for="select-state">To Date:</label>
                                <input
                                  min={formDate}
                                  type="date"
                                  onChange={toDateHandler}
                                  value={toDate}
                                />
                              </div>

                              <div className="fbtn">
                                <button
                                  className="btn"
                                  type="submit"
                                  id="btnapply"
                                  disabled={checkDisable()}
                                >
                                  Apply
                                </button>
                                <button
                                  className="btn"
                                  type="reset"
                                  id="btnclear"
                                  onClick={resetApply}
                                >
                                  Clear
                                </button>
                              </div>
                            </form>
                          </div>
                        </div> */}
                        <div class="dropdown fltr">
                          <button
                            type="button"
                            title="Filter"
                            class="filter dropdown-toggle"
                            id="fillist"
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="false"
                            aria-expanded="false"
                            // style={{border:'2px solid rgb(132, 133, 135)'}}
                          >
                            Filter
                          </button>
                          <div
                            class="dropdown-menu dropdown-menu-end"
                            id="filterbox"
                            aria-labelledby="fillist"
                          >
                            <form onSubmit={applyStatus}>
                              <div class="filters">
                                <label for="select-state">From Date:</label>
                                <input
                                  type="date"
                                  onChange={txnFromDateHandler}
                                  value={formDate}
                                />
                              </div>

                              <div class="filters">
                                <label for="select-state">To Date:</label>
                                <input
                                  min={formDate}
                                  max={today}
                                  type="date"
                                  onChange={txnToDateHandler}
                                  value={toDate}
                                />
                              </div>
                              <div class="fbtn">
                                <button
                                  class="btn"
                                  type="submit"
                                  id="btnapply"
                                  // disabled={checkDisable()}
                                >
                                  Apply
                                </button>
                                <button
                                  class="btn"
                                  type="button"
                                  id="btnapplys"
                                  onClick={onExportData}
                                  // disabled={checkDisable()}
                                >
                                  Export
                                </button>
                                <button
                                  class="btn"
                                  type="reset"
                                  id="btnclear"
                                  style={{
                                    backgroundColor: "#f8d7da",
                                    color: "#721c24",
                                  }}
                                  onClick={clearFilterhData}
                                >
                                  Clear
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                        <div>
                          <button
                            style={{
                              height: "33px",
                              backgroundColor: primaryColor,
                              // cursor: checkPermission(MERCHANTLIST_ADDMERCHANT_EDIT, roles)
                              //   ? "pointer"
                              //   : "not-allowed",
                            }}
                            // disabled={!checkPermission(MERCHANTLIST_ADDMERCHANT_EDIT, roles)}
                            className="btn"
                            type="button"
                            onClick={() => handleShow()}
                          >
                            Add
                          </button>
                        </div>
                        <div
                          style={{ backgroundColor: primaryColor }}
                          className="search allsearch"
                        >
                          <form autocomplete="off" action="#">
                            <div className="autocomplete">
                              <input
                                id="myInput"
                                type="text"
                                name=""
                                style={{ backgroundColor: primaryColor }}
                                placeholder="Search"
                                value={searched?.name}
                                onChange={searchdata}
                              />
                              <button
                                type="button"
                                onClick={clearSearchData}
                                style={{
                                  position: "absolute",
                                  backgroundColor: darkenColor(primaryColor),
                                }}
                                className="search-btn"
                              ></button>
                              {search !== undefined &&
                                search !== null &&
                                searchedByItemShow &&
                                search.length > 2 &&
                                searchTyping && (
                                  <div
                                    id="myInputautocomplete-list"
                                    className="autocomplete-items"
                                    style={{
                                      marginTop: "3px",
                                      borderTopLeftRadius: "7px",
                                    }}
                                  >
                                    <button
                                      style={{
                                        background: "#9FA6B2",
                                        width: "30px",
                                        height: "30px",
                                        fontSize: "20px",
                                        borderRadius: "20px",
                                        opacity: 1,
                                      }}
                                      type="button"
                                      className="close"
                                      aria-label="Close"
                                      onClick={() => setSearchTyping(false)}
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                    {search !== undefined &&
                                      search !== null &&
                                      search.length > 2 &&
                                      searchedByItem.map((val, index) => {
                                        return (
                                          <div
                                            key={index}
                                            onClick={() => {
                                              setSearchedBy(val);
                                              setSearchedByItemShow(true);
                                            }}
                                            style={{
                                              backgroundColor: `${
                                                searchedBy == val
                                                  ? "#d0d2d6"
                                                  : "#fff"
                                              }`,
                                            }}
                                          >
                                            {val}
                                            <input
                                              type="hidden"
                                              value="Denmark"
                                            />
                                          </div>
                                        );
                                      })}
                                  </div>
                                )}
                            </div>
                          </form>
                        </div>
                      </div>
                      <UpdatTicket
                        ticketRequest={ticketRequest}
                        tokenChangeHandle={ticketChangeHandle}
                        attachmentId={attachmentId}
                        show={show}
                        handleClose={handleClose}
                        handleShow={handleShow}
                        fetchpagedata={fetchpagedata}
                      />
                    </div>
                    <div className="txn-list" id="recntxn">
                      {dataLoading ? (
                        <UILoader />
                      ) : (
                        <>
                          {table !== undefined &&
                          table !== null &&
                          isDataLoaded &&
                          table.length == 0 ? (
                            <h6>No Record Found</h6>
                          ) : table !== undefined &&
                            table == null &&
                            isDataLoaded ? (
                            <h6>No Record Found</h6>
                          ) : (
                            table?.map((data) => {
                              return (
                                <div className="txn-item" key={data.id}>
                                  <div className="txn-head" id="txnhead1">
                                    <div
                                      className="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#txn1"
                                      aria-expanded="false"
                                      aria-controls="txn1"
                                    >
                                      <div
                                        className={`txncard ${
                                          data?.currentStatus == "CLOSED"
                                            ? "success grbg"
                                            : "pending ylbg"
                                        }
                                      }`}
                                      >
                                        <div className="row">
                                          <div className="col-12 col-md-3">
                                            <div className="txntxt">
                                              <h6>
                                                <span>
                                                  {createdOnDate(
                                                    data?.createdOn
                                                  )}{" "}
                                                </span>{" "}
                                              </h6>
                                            </div>
                                          </div>

                                          <div className={"col-12 col-md-4"}>
                                            <div
                                              className="txntxt"
                                              onClick={() =>
                                                copyTextToClipboard(
                                                  data?.ticketId,
                                                  toast
                                                )
                                              }
                                            >
                                              <h6>
                                                TicketId: {data?.ticketId}
                                                <MdContentCopy
                                                  style={{
                                                    color: primaryColor,
                                                  }}
                                                />
                                              </h6>
                                            </div>
                                          </div>
                                          <div className={"col-12 col-md-3"}>
                                            <div
                                              className="txntxt"
                                              onClick={() =>
                                                copyTextToClipboard(
                                                  data?.txnId,
                                                  toast
                                                )
                                              }
                                            >
                                              <h6>
                                                TxnId: {data?.txnId}
                                                <MdContentCopy
                                                  style={{
                                                    color: primaryColor,
                                                  }}
                                                />
                                              </h6>
                                            </div>
                                          </div>
                                          <div className="col-12 col-md-1">
                                            <div className="txntxt">
                                              <h4 style={{ float: "left" }}>
                                                {" "}
                                                <span
                                                  className={`${
                                                    data?.currentStatus ===
                                                    "CLOSED"
                                                      ? "success"
                                                      : `${
                                                          data?.currentStatus ===
                                                          "INPROGRESS"
                                                            ? "pending"
                                                            : "failed"
                                                        }`
                                                  }`}
                                                >
                                                  {data.currentStatus}
                                                </span>
                                              </h4>
                                            </div>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                            }}
                                            class="col-12 col-md-1"
                                          >
                                            {
                                              <div>
                                                <h4
                                                  onClick={() =>
                                                    openDetailsPage(data)
                                                  }
                                                >
                                                  <TiEyeOutline
                                                    size={33}
                                                    style={{
                                                      color: primaryColor,
                                                      cursor: "pointer",
                                                    }}
                                                  />
                                                </h4>
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          )}

                          <div className="pager">
                            {table !== undefined &&
                              table !== null &&
                              table.length > 0 &&
                              search == "" && (
                                <p>
                                  Total Records:{" "}
                                  {paginationDetails?.totalPost > 0 &&
                                    paginationDetails?.totalPost}
                                  {/* {paginationDetails.currentPage !==
                                    undefined &&
                                    paginationDetails.currentPage !== null &&
                                    paginationDetails.totalPost !== undefined &&
                                    paginationDetails.totalPost !== null &&
                                    table !== undefined &&
                                    Array.isArray(table) &&
                                    setpageContent(
                                      paginationDetails.currentPage - 1,
                                      table.length,
                                      paginationDetails.totalPost
                                    )} */}
                                  {/* <button
                                    className={
                                      isExportable
                                        ? "lbbtn"
                                        : "lbbtn-disable-btn"
                                    }
                                    disabled={!isExportable}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="First select the filter than you can export"
                                    type="button"
                                    onClick={onExportData}
                                  >
                                    Export xlsx
                                  </button> */}
                                  {/* <button
                                    className={
                                      isExportable
                                        ? "lbbtn"
                                        : "lbbtn-disable-btn"
                                    }
                                    disabled={!isExportable}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="First select the filter than you can export"
                                    type="button"
                                    onClick={onExportData}
                                  >
                                    Export csv
                                  </button> */}
                                </p>
                              )}

                            {/* {paginationDetails.totalPost !== undefined &&
                              paginationDetails.totalPost !== null &&
                              paginationDetails.totalPost > 10 &&
                              search == "" && (
                                <Pagination
                                  className="pagination-bar"
                                  currentPage={paginationDetails.currentPage}
                                  totalCount={paginationDetails.totalPost}
                                  pageSize={paginationDetails.postsPerPage}
                                  onPageChange={(page) => handalpageclick(page)}
                                />
                              )} */}
                            {paginationDetails.totalPages !== undefined &&
                              paginationDetails.totalPages !== null &&
                              paginationDetails.totalPages >= 1 &&
                              search == "" && (
                                <Pagination
                                  className="pagination-bar"
                                  currentPage={paginationDetails.currentPage}
                                  totalCount={paginationDetails.totalPost}
                                  pageSize={paginationDetails.postsPerPage}
                                  onPageChange={(page) => paginate(page)}
                                />
                              )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default TicketList;
